import { useState, useEffect, useMemo,useRef } from "react";
import ReactDatetime from "react-datetime";
import React from 'react';
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  useHistory,
} from "react-router-dom";
import {
  Label,
  Badge,
  Button,
  Card,
  CardHeader,
  CardFooter,
  Table,
  Container,
  Row,
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Modal,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  PopoverBody,
  UncontrolledPopover,
  
} from "reactstrap"; 
import swal from "sweetalert";
import { ToastContainer, toast } from "react-toastify";
import { AgGridReact, AllCommunityModules, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-community/dist/styles/ag-theme-alpine-dark.css";
import { userService } from "../../services/authentication";
import "../../assets/css/custom.css";
import Header from "components/Headers/Header.js";
import { disposeEmitNodes, ExitStatus, forEachChild } from "typescript";
import { taskmanageService } from "../../services/taskmanageService";
import { usermanageService } from "../../services/usermanageService";
import { clientmanageService } from "../../services/clientmanageService";
import { manageService } from "../../services/manageaccountservices";
import { permissions, rolename, roletype } from "global.js";
import { map } from "jquery";
import 'assets/css/themecustom-style.css';
import { connect } from "react-redux";
import moment from 'moment';
import Select from 'react-select';
import {todoService} from '../../services/todoService.js';
import Paginationcomponent from "components/Paginationcomponent.js"
const Billingdashboard = (props) => {
  let start_d =  moment().startOf('month').format('YYYY-MM-DD');
  let end_d = moment().endOf('month').format('YYYY-MM-DD');
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [state, setState] = useState({startDate:'',endDate:''});
  const [statesend, setStatesend] = useState({startDate:'',endDate:''});
  const history = useHistory();
  const [dashboarddata, setDashboarddata] = useState([]);
  const [tempdashboarddata, setTempDashboarddata] = useState([]);
  const [statuslist, setStatusdata] = useState([]);
  const [currentPage, setCurrentPage] = useState(null);
  const [last_page, setLastPageData] = useState(0);

  const [companieslist, setCompaniesData] = useState([]);
  const [tempcompanieslist, setTempCompaniesData] = useState([]);
  const [dashboardStatistics, setdashboardStatistics] = useState([]);
  const [phaselistsselection, setPhaseListsSelection] = useState([]);
  const [analystListsSelection, setAnalystListsSelection] = useState({assign_lead_id : '',due_date:''});
  const [processOrder, setprocessOrder] = useState(0);
  const [analysteamleaderlist, setAnalystTeamLeaderList] = useState([]);
  const [companylist, setCompanies] = useState([]);
  const [tempallcompanylist, setAlltempCompanieslist] = useState([]);
  const [total_page,setTotalData] = useState(0);
  const [commentModalOpen, setCommentModalOpen] = useState(false);
  const [documentModalOpen, setdocumentModalOpen] = useState(false);
  const [rejectionModalOpen, setrejectionModalOpen] = useState(false);
  const [otherInfoModalOpen, setotherInfoModalOpen] = useState(false);
  const [expandedRows, setexpandedRows] = useState([]);
  const [commentlists, setCommentLists] = useState([]);
  const [documentlists, setDocumentLists] = useState([]);
  const [rejectionlists, setRejectionLists] = useState([]);
  const [dataloaded,setdataloaded] = useState(false);
  const [mainfilter,setmainfilter] = useState('assigned');
  const [status, setStatus] = useState(0); // 0: no show, 1: show yes, 2: show no.
  const [disablestate, setdisablestate] = useState(false);
  const [clienttransModalOpen, setClienttransModalOpen] = useState(false);
  const [clienttranslists, setClienttransLists] = useState([]);
  const [reviewChecklist,setReviewChecklistModalOpen] = useState(false);
  const [reviewMasterChecklist,setReviewChecklistMasterModalOpen] = useState(false);
  
  const rowsPerPageOptions = [5, 10, 25, 50, 100];
  const [checklistData, setCheckListData] = useState([]);
  const [checklistMasterData, setCheckListMasterData] = useState([]);
  const [sendmailpopup,setsendmailPopup] = useState(false);
  const [sendmailpopupdata, setsendmailpopupdata] = useState([]);
  const formRef = useRef();
  const initialStateData = {
    invoice_date: "",
    client_id: "",
    block_name: "",
    amount:"",
    description:"",
    address:"",
    email:"",
    client_name:""
  };
  const initialStateDataRejection = {
    id: "",
    type : "",
    value : "",
    comment : "",
    errors : []
  };
  const initiaPhaseData = {
    phases: [],
  };
  const commentData = {
    task_id: "",
    comment: "",
    is_client : 0
  };
  
  const [inputFields, setInputfields] = useState(initialStateData);
  const [inputPhases, setinputPhases] = useState(initiaPhaseData);
  const [inputFieldsRejection, setInputfieldsRejection] = useState(initialStateDataRejection);
  const [inputPhasesRejection, setinputPhasesRejection] = useState(initiaPhaseData);
  const [inputComments, setinputComments] = useState(commentData);
  const [error, setError] = useState(null);
  const [filterFields,setfilterFields] = useState([]);
  const [filtertype,setfiltertype] = useState('pending');
  const [successMsg, setsuccessMsg] = useState(null);
  const [completedCount,setCompletedCount] = useState(0);
  const [errorcategory,seterrorcategory] = useState([]);
  const [errorbox,seterrorbox] = useState([
    0
  ]);
  const errorDiv = error ? (
    <UncontrolledAlert className="alert-danger" fade={false}>
      {error}
    </UncontrolledAlert>
  ) : (
    ""
  );
  const successDiv = successMsg ? (
    <UncontrolledAlert className="alert-success" fade={false}>
      {successMsg}
    </UncontrolledAlert>
  ) : (
    ""
  );
  function inputhandler(e,key) {
    if(key=='client_id'){
      setInputfields({ ...inputFields, [key]: e.label });
    }else{
    setInputfields({ ...inputFields, [e.target.name]: e.target.value });
    }
  }

  function inputhandlercomment(e) {
    setinputComments({ ...inputComments, [e.target.name]: e.target.value });
  }

  const handleclick = (e, value) => {
    history.push({
      pathname: "addedit",
    });
  };
  const todohandleclick = (e, value) => {
    history.push({
      pathname: "todolist",
    });
  };
  useEffect(() => {
    get_unique_companieslist();
    if(!dataloaded){
      get_status_list();
      get_companieslist();
      get_dashboard_data();
      getPhases();
    }
    search_all_company();
    return () => {
      setDashboarddata([]);
      setCompaniesData([]);
      setdashboardStatistics([]);
      setAnalystTeamLeaderList([]);
    };
  }, [props.name]);

  // sorting functon
  const [sortfield,setsortfield] = useState('');
  const [sortorder,setsortorder] = useState('asc');
  function sortTable(field){
    console.log(field)
    setsortfield(field);
    if(sortorder=='asc'){
      setsortorder('desc');
    }else{
      setsortorder('asc');
    }
  }
  useEffect(() => {
    if(dataloaded){
    get_list(1,null,filterFields,filtertype);
    }
  }, [sortorder]);
  const[filterphaselist,setFilterPhaseList]=useState([]);
  function getPhases(){
    taskmanageService.getPhases().then((response)=>{
      if (response.status == 200) {
 
        setFilterPhaseList(response.data.data)
      }
    })
  }

  // end sorting functon

  const user_info = JSON.parse(localStorage.getItem("user-info"));
  
  const get_list = async (pageNumber = 1,e,filterFields,filtertype='',start_date='',end_date='',rowsPerPage='',phase_id='') => {
    let  textbox = '';
 
    if(e != null){
       textbox = e.target.value;
    }
   
    taskmanageService.gettasks(pageNumber,textbox,filterFields,filtertype,sortfield,sortorder,start_date,end_date,rowsPerPage,phase_id).then((response) => {
      setDashboarddata(response.data.data.data);
      setTempDashboarddata(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
      setCompletedCount(response.data.completed_count)
      setLastPageData(response.data.data.last_page);
      setTotalData(response.data.data.total);
     // setRowsPerPage(response.data.data.per_page);
    });
  };
  function get_status_list() {
    taskmanageService.getstatus().then((response) => {
      setStatusdata(response.data.status);
    });
  }
  function get_dashboard_data() {
    taskmanageService.getDashboardData().then((response) => {
      setdashboardStatistics(response.data.data);
    });
  }
  function get_companieslist(e) {
    let textbox = '';
    if(e != null){
       textbox = e.target.value;
       if(e.key === 'Enter'){
        e.preventDefault();
        taskmanageService.getcompanieslistsname(textbox).then((response) => {
          setCompaniesData(response.data.data);
          setTempCompaniesData(response.data.data);
          setdataloaded(true);
        });
      }else if(e.target.value.length <= 1){
        taskmanageService.getcompanieslistsname(textbox).then((response) => {
          setCompaniesData(response.data.data);
          setTempCompaniesData(response.data.data);
          setdataloaded(true);
        });  
      }
    }else{
      taskmanageService.getcompanieslistsname(textbox).then((response) => {
        setCompaniesData(response.data.data);
        setTempCompaniesData(response.data.data);
        setdataloaded(true);
      });
    }
  }

  function searchcompany(e){
    let  textbox = '';
    if(e != null){
       textbox = e.target.value;
    }
    let empty_arr = [];
    companieslist.map((value,index) => {
       if(value.name == textbox){
           empty_arr.push(value); 
       }else if(textbox == ''){
           empty_arr.push(value);    
       }
    });
    setTempCompaniesData(empty_arr); 
  }
   
  function getcompanies(){
    manageService.get_allcompanies_with_subclient().then((response)=>{
       setCompanies(response.data);
       setAlltempCompanieslist(response.data);
    });
  }

  function search_all_company(){
    let textbox = props.name;
    let pageNumber = 1;
    taskmanageService.gettasks(pageNumber,textbox,filterFields,filtertype,sortfield,sortorder,statesend.startDate,statesend.endDate,rowsPerPage).then((response) => {
      if (response.status == 200) {
      setDashboarddata(response.data.data.data);
      setTempDashboarddata(response.data.data.data);
      setCurrentPage(response.data.data.current_page);
       setTotalData(response.data.data.total);
      setLastPageData(response.data.data.last_page);
    
      //setRowsPerPage(response.data.data.per_page);
      
      }
    });

  }

 
 
  const formatDate = (dateStr) => {
    if(dateStr!=null && dateStr!=''){

      const [year, month, day] = dateStr.split('-');
      let newDate = `${day}-${month}-${year}`;
      return newDate;
    }
  };

  let button = "";
  let phase = "";
  let amendement = "";
  let taskapprove = false;
  let taskstatusedit = false;
  let phaseapprove = false;
  let phasestatusedit = false;
  let analystapprove = false;
  let analyststatusedit = false;
  let taskassign = false;
  let phaseassign = false;
  let analystassign = false;
  let taskedit = false;
  let phaseedit = false;
  let analystedit = false;
  let todo = "";


  const [
    PhaseSelectionModalOpen,
    setPhaseSelectionModalOpen,
    collapseOpen,
    setCollapseOpen,
  ] = useState(false);
  const [CompanySelectionModal, setCompanySelectionModal] = useState(false);
  const [isCheckedPhase, setIsCheckedPhase] = useState(false);
  const [isCheckedPhase_test, setIsCheckedPhase_test] = useState({});
  const [amendmentModalOpen, setAmendmentModal] = useState(false);
  const [amendmentsecondModal, setAmendmentsecondModal] = useState(false);
  const [opensecondpopup, setsecondpopup] = useState(false);
  const [editbox, seteditbox] = useState({ids: []});
  const [checkindex, setcheckindex] = useState([]);
  const initial_amend = {
    am_company: '',
    am_company_name: '',
    am_analyst: '',
    select_due_date: '',
    am_budget: '',
  };
  const [amendmentdata, setAmendmentdata] = useState(initial_amend);
  const [filterlist, setfilterlist] = useState([]);
  const [showfilterbox,setshowfilterbox] = useState(false);
  const [filterApplyFields,setfilterApplyFields] = useState([]);
  const [showRejection,setshowRejection] = useState(false);
  const [rejectionindex,setrejectionindex] = useState('');

const [checkstate, setchecklistState] = useState({task_id:null,phase_id:null,data:null});
  const [decesionmakingmatrixModalOpen, setotherDecisionmakingmatrixModalOpen] = useState(false);
  useEffect(() => {
    if(filterApplyFields.length > 0){

      applyFilter('true');
    }
  }, [filterApplyFields]);


  function inputphasehandler(e, index) {
    const cloneValues = [...inputPhases];
    cloneValues[index] = {
      ...cloneValues[index],
      [e.target.name]: e.target.value,
    };
    setinputPhases(cloneValues);
  }

  const handleOnChange = (e, index) => {
    let temp_state = [...phaselistsselection];
    let temp_element = { ...temp_state[index] };
    temp_element.already_assign = temp_element.already_assign ? false : true;
    temp_state[index] = temp_element;
    setPhaseListsSelection(temp_state);
    if (temp_element.already_assign) {
      const cloneValues = [...inputPhases];
      cloneValues[index] = {
        ...cloneValues[index],
        [e.target.name]: e.target.value,
      };
      setinputPhases(cloneValues);
      setinputPhasesRejection(cloneValues);
    } else {
      let state = [...inputPhases];
      console.log(state)
      delete state[index];
      setinputPhases(state);
      let cloneValues = [...inputPhasesRejection];
      delete cloneValues[index];
      
      setinputPhasesRejection(cloneValues);
    }
   
  };

  function get_error_category(){
    taskmanageService.geterrorcategories().then((response) => {
      seterrorcategory(response.data)
    })
  }

  function openRejectionModal(value='',id='',type='',task_id='',index){
    get_error_category();
    setshowRejection(!showRejection);
    const dataRejection = {
      id: id,
      type : type,
      value : value,
      comment : '',
      errors : []
    };
    setInputfieldsRejection(dataRejection);
    if(id==''){
      seterrorbox([0])
      setRowsError(1)
    }
    setrejectionindex(index)
  }

  function inputtaskrejectionhandler(e,index) {
    const cloneValues = {...inputFieldsRejection};
      cloneValues.errors[index] = {
        ...cloneValues.errors[index],
        [e.target.name]: e.target.value,
      };
    console.log(cloneValues)
    
    setInputfieldsRejection(cloneValues);
    
    if(e.target.name == 'no_error'){
      const errorsInput = [...errorbox];
      errorsInput[index] = e.target.value;
      seterrorbox(errorsInput)
    }
  }
  
  const [rowsError, setRowsError] = useState(1);
 
  const addCommetbox = ()=>{
    const setdata = rowsError+1;
      setRowsError(setdata)
    const errorsInput = [...errorbox];
    errorsInput[rowsError] = 0;
    seterrorbox(errorsInput)
  }

  function inputrejectionhandler(e, index) {
    const cloneValues = [...inputPhasesRejection];
    cloneValues[index] = {
      ...cloneValues[index],
      [e.target.name]: e.target.value,
    };
    console.log(cloneValues)
    setinputPhasesRejection(cloneValues);
    if(e.target.name == 'no_error'){
      const errorsInput = [...errorbox];
      errorsInput[index] = e.target.value;
      seterrorbox(errorsInput)
    }
  }

  const handleeditRow = (index) => {
    if(phasestatusedit == true || taskstatusedit == true || analyststatusedit == true){
      let temp_state = [...dashboarddata];
      let temp_element = { ...temp_state[index] };
      temp_element.editing = true;
      temp_state[index] = temp_element;
      setDashboarddata(temp_state);
      }

  };

  const handlePageClick = (e, index) => {
 
    e.preventDefault();
    get_list(index,null,filterFields,filtertype,'','',rowsPerPage);
  };

  const handlePreviousClick = () => {
    const prev = currentPage - 1;
    get_list(prev,null,filterFields,filtertype,'','',rowsPerPage);
  };

  const handleNextClick = () => {
    const next = currentPage + 1;
    get_list(next,null,filterFields,filtertype,'','',rowsPerPage);
  };

  const getFilterList = () => {
    taskmanageService.getfilterlist().then((response) => {
      setfilterlist(response.data.filter);
      setshowfilterbox(!showfilterbox);
    })
  }


  const [sendmailbodydata, setsendmailbodydata] = useState({emailbody:'',name:'', emailtoboxData : [],emailccboxData:[]});

  function phaseModalCancel() {
    setCompanySelectionModal(!CompanySelectionModal);
    setInputfields(initialStateData);
    setinputPhases(initiaPhaseData);
  }

  const [taskdetails,settaskdetails] = useState({});
  const [taskdetailPopup,settaskdetailPopup] = useState(false);
  const taskDetail = (task_id,index,id,type) => {
    taskmanageService.gettaskdetail(task_id,id,type).then((response) => {
      settaskdetails(response.data.data);
      setDocumentLists(response.data.files);
      setRejectionLists(response.data.rejections);
      settaskdetailPopup(!taskdetailPopup);
      setuserid(response.data.data.user_id)
    })
  }

  const handleExpand = (task, index) => {
    let temp_state = [...dashboarddata];
    let temp_element = { ...temp_state[index] };
    temp_element.toggle = temp_element.toggle ? false : true;
    temp_state[index] = temp_element;
    setDashboarddata(temp_state);
  };

  const applyFilter = (e='') => {
    get_list(1,null,filterFields,filtertype);
    if(e==''){
      setfilterApplyFields(filterFields);
      document.getElementById('tooltipfilter').click();
    }
  }
  const removefromFilter = (index) => {
    let state = {...filterFields};
    Object.entries(state) // converts each entry to [key, value]
      .filter(([k, v]) => v.field == index) // define the criteria to include/exclude items
      .reduce((acc, [k, v]) => {
         delete state[k];
         setfilterFields(state);
         setfilterApplyFields(state);
      }, {});
  }

 
 

  function editclient(){
    // console.log('edit box');
    // console.log(editbox.ids[0]);
    history.push({
      pathname: "editclient/"+editbox.ids[0],
      // search: '?id='+editbox.ids[0],
    });

  }
function downloadReport(){
 
  taskmanageService.download_report(filterFields,filtertype,statesend.startDate,statesend.endDate,1).then((response) => {
  
  });
}

function ageingreport(){
  history.push({
    pathname: "ageingreport/",
  });
  
}

const [loading, setLoading] = useState(false);


function filterallcom({type}){
   setfiltertype(type)
   setmainfilter(type);
   get_list(1,null,filterFields,type);
}

function Companysearch(e){
    e.preventDefault();
    //  console.log('event target');
    //  console.log(e.target.compnayname.value);
    //  var company_data = document.getElementById('companydata').value;
    //  console.log(company_data);
}
const disablePastDate = () => {
  const today = new Date();
  const dd = String(today.getDate() + 1).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return yyyy + "-" + mm + "-" + dd;
};


const [formdetails,setformdetails] = useState({});
const [formdname,setformname] = useState({});
const [userid,setuserid] = useState(false);

const [ assignuserlist, setassignuserlist ] = useState([])
const assignuser = ()=>{
  todoService.get_assignuser(user_info.id).then((response) => {
  
    if(response.status === 200){
      setassignuserlist(response.data.data)
      
    }
  });
}


function setEndDateRange(e){
  var month = e._d.getMonth() + 1;
  var date = e._d.getDate();
  var year = e._d.getFullYear();
  var dd = date + '-' + month + '-' + year;
  setStatesend({ ...statesend,endDate: dd });
  setState({ ...state,endDate: e });
  get_list(1,null,filterFields,filtertype,statesend.startDate, dd);
}
function setStartDateRange(e){
  var month = e._d.getMonth() + 1;
  var date = e._d.getDate();
  var year = e._d.getFullYear();
  var dd = date + '-' + month + '-' + year;
  setStatesend({ ...statesend, startDate: dd })
  setState({ ...state, startDate: e })
  
}
//let handleRowsPerPageChange ;
// const [ assignuserlist, setassignuserlist ] = useState([])



const handleRowsPerPageChange = (newRowsPerPage) => {

  setRowsPerPage(newRowsPerPage);
  
  setCurrentPage(1); 
  get_list(1,null,filterFields,filtertype,statesend.startDate,statesend.endDate,newRowsPerPage)

};




  const scrollContainerRef = useRef(null);
  const scrollLeft = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft -= 100; // Adjust scroll distance as needed
    }
  };

  const scrollRight = () => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollLeft += 100; // Adjust scroll distance as needed
    }
  };


  const [uniquecompanieslist, setUniqueCompaniesData] = useState([]);
  function get_unique_companieslist(){
    clientmanageService.getuniqueclient().then((response)=>{
      console.log(response)
      setUniqueCompaniesData(response.data);
    });
    
  }
  const [selectedTaskId,setselectedtask] = useState(null);
  const [selectedSubClientName,setselectedSubClientName] = useState(null);
  function getpopupdata(id,client_name,i,sub_client){
   let defaultCC = [
  'kalpesh.mhamunkar@corientbs.com',
  'sachin.lohade@corientbs.co.uk',
  'pooja.sail@corientbs.co.uk',
  'ravindra.padte@corientbs.co.uk',
  'gazal.toshniwal@corientbs.co.uk'
];

setsendmailbodydata(prevState => ({
  ...prevState,
  emailccboxData: dashboarddata[i].cc_email.length > 0 && dashboarddata[i].cc_email !=''
    ? [...dashboarddata[i].cc_email, ...defaultCC]
    : [...defaultCC],
  emailtoboxData: ['manali.nimase@corientbs.com']
}));
console.log(sendmailbodydata)
    setselectedtask(id)
    setselectedSubClientName(sub_client)
     setInputfields({ ...inputFields, address: dashboarddata[i].address,contact_person: dashboarddata[i].contact_person,email: dashboarddata[i].email,block_name:sub_client,invoice_date:new Date().toISOString().split('T')[0],name:'Manali' });
    console.log(inputFields)
    setsendmailPopup(!sendmailpopup);
    
  }
  const customStyles = {
    cell: {
      border: '1px solid black',
      padding: '5px',
      // textAlign: 'center',
    },
    '#main_table tr': {
      padding: 0,
    },
    '#main_table tr th': {
      color: 'white',
      fontWeight: 700, // Removed 'px' from the value
      border: '1px solid black',
      backgroundColor: '#0867d2',
      padding: '5px', // Removed 'px' from the value
      textAlign: 'left', // Corrected property name
    },
    oddRow: {
      backgroundColor: '#f2f2f2',
    },
    evenRow: {
      backgroundColor: '#ffffff',
    },
  };
  const noscroll = {
    overflow: 'hidden'
  }
  const addCCbox = () => {
    setsendmailbodydata(prevState => ({
      ...prevState,
      emailccboxData: [...prevState.emailccboxData, ''] // Add an empty string for a new input
    }));
  };
  const [tobox, setToBox] = useState(0);
  const [ccbox, setCCBox] = useState(0);
  const [selecteduser,setselecteduser] = useState(false);
  function sendmail(flag=0){
    setdisablestate(true);
    let id = selectedTaskId;

    taskmanageService.addbillingdashboard(id,inputFields,sendmailbodydata.emailccboxData,sendmailbodydata.emailtoboxData).then((response) => {
      if(response.status==200){
      toast.success(response.data.message);
      setsendmailPopup(!sendmailpopup);
      setdisablestate(false);
      setInputfields(initialStateData);
      }
    });
  }
const [allclient, setAllclient] = useState(true);
const [filteractive, setFilterActive] = useState(false);
  const companyfilter = (e,index,field) => {
    console.log(e)
    if(e.value == ''){
      setAllclient(true);
    }else{
      setAllclient(false);
      setFilterActive(true);
      
    }
    const cloneValues = {...filterFields};
    cloneValues[index] = {
      ...cloneValues[index],
      ['field']: field,
      ['value']: e.value,
      ['operator']: '='
    };
    setfilterFields(cloneValues);
    get_list(1,null,cloneValues,filtertype,statesend.startDate, statesend.endDate);
    get_dashboard_data(statesend.startDate, statesend.endDate,e.value);
  }
  const addTObox = () => {
    setsendmailbodydata(prevState => ({
      ...prevState,
      emailtoboxData: [...prevState.emailtoboxData, ''] // Add an empty string for a new input
    }));
  };
  const inputTomailhandler = (e,k)=>{
    const cloneValues = {...sendmailbodydata};
    cloneValues['emailtoboxData'][k] = e.target.value;
    setsendmailbodydata(cloneValues);
  }
  const removeToEmailbox =(k)=>{
    
    const updatedEmails = [...sendmailbodydata.emailtoboxData];
    updatedEmails.splice(k, 1);
console.log(updatedEmails)
    setsendmailbodydata(prevState => ({
        ...prevState,
        emailtoboxData: updatedEmails,
    }));

    // Update the email box count if needed
    if (tobox > 0) {
      const setdata = tobox-1;
      setToBox(setdata)
        
    }
  }
  const removeEmailbox =(k)=>{
    
    const updatedEmails = [...sendmailbodydata.emailccboxData];
    updatedEmails.splice(k, 1);

    setsendmailbodydata(prevState => ({
        ...prevState,
        emailccboxData: updatedEmails,
    }));

    // Update the email box count if needed
    if (ccbox > 0) {
      const setdata = ccbox-1;
      setCCBox(setdata)
        
    }
  }
  const inputCCmailhandler = (e, k) => {
    const newEmailCCData = [...sendmailbodydata.emailccboxData];
    newEmailCCData[k] = e.target.value; // Update the specific index with the new value
    setsendmailbodydata(prevState => ({
      ...prevState,
      emailccboxData: newEmailCCData
    }));
  };
  const handlemaineditRow = (index) => {
    let temp_state = [...dashboarddata];
    let temp_element = { ...temp_state[index] };
    temp_element.mainediting = true;
    temp_state[index] = temp_element;
    setDashboarddata(temp_state);

};
const editField = (value, field, id, index) => {
  taskmanageService.editBillingRow(value, field, id).then((response) => {
    let temp_st = [...dashboarddata];
    let temp_ele = { ...temp_st[index] };
   
    if(response.status == 200){
        
        toast.success(response.data.message);
        temp_ele[field] = value;
    }else{
        toast.error(response.data.message);
    }
    temp_ele.mainediting = false;
    temp_st[index] = temp_ele;
    setDashboarddata(temp_st);
  });
};
  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
       
    
      
        <Row className="mt-4">
          <button type="button" style={filtertype == 'pending' ?
          { backgroundColor:'#5d6cae',color:'#fff',fontFamily:'inherit',margin: '7px 0px'} : {fontFamily:'inherit',margin: '7px 0px'}} onClick={() => filterallcom({type:'pending'})} className=" btn btn-secondary text-center">
            Pending
          </button>
          <button type="button" style={filtertype == 'sent' ?
          { backgroundColor:'#5d6cae',color:'#fff',fontFamily:'inherit',margin: '7px 0px'} : {fontFamily:'inherit',margin: '7px 0px'}} onClick={() => filterallcom({type:'sent'})} className=" btn btn-secondary text-center">
            Sent
         
          </button>
        </Row>
      
        <Row className="mt-4">
          <div className="col" style={{padding:'0%'}}>
            <Card className="shadow">
              <CardHeader className="border-0">
                <Row className="filter" style={{padding:'0 1%'}}>
         
                   <div className="col-4 mt--3">
                      <label>Select Client</label>
                    
                   <Select 
                   
                   className="input-group-alternative " 
                   name="user_id"
                   options={uniquecompanieslist} // set list of the data
                   onChange={(e) => companyfilter(e,9,'user_id')}
                  //  value={usersearch}
                   searchable
                   isClearable={false}
                 />
                
                      </div>
                      <div   style={{maxWidth:'50%'}}>
                    <Button
                      className="btn-icon-clipboard"
                      type="button"
                      onClick={downloadReport}
                      style={{textAlign:'center'}}
                      title="Download Report"
                    >
                    <i className="fas fa-download" style={{fontSize:'14px'}}></i> Export
                    </Button>
                    </div>
                  
                </Row>
              
               
                
              <div className="scroll-div"><button className="scroll-button" onClick={scrollLeft}><i className="fa fa-angle-left"></i></button>&nbsp;&nbsp;<button className="scroll-button" onClick={scrollRight}><i className="fa fa-angle-right"></i></button></div>
              </CardHeader>
              
                <div className="scroll-container"  ref={scrollContainerRef}>
              <div className="scroll-content">
              
              <Table className="align-items-center table-flush mt-5" responsive>
      <thead className="thead-light">
        <tr>
          <th scope="col" className="whitespace sortclass" onClick={() => sortTable('name')}>
            Client Name
          </th>
          <th scope="col" className="whitespace sortclass" onClick={() => sortTable('sub_client')}>
            Sub Client
          </th>
          
          {/* Conditionally render Phase name column based on user role */}
          {(user_info.role_id === 10 || user_info.role_id === 6 || user_info.role_id === 7) && (
            <th scope="col" className="whitespace">Phase name</th>
          )}
          
          <th scope="col">Year endDate</th>
          <th scope="col" className="whitespace">Status</th>
          <th scope="col" className="whitespace">Budget</th>
          {filtertype == 'sent' ?
          <>
          <th scope="col" className="sortclass" onClick={() => sortTable('approval_date')}>Amount</th>
          
          <th scope="col" className="sortclass" onClick={() => sortTable('invoice_date')}>Invoice date</th>
          </>
          : null }
          {/* Conditionally render Assign Lead or Processor based on phase_id */}
          <th>{user_info.phase_id ? 'Processor' : 'Assign Lead'}</th>
          <th className="whitespace" scope="col">
            {user_info.phase_id ? 'Reviewer' : 'Assign TM'}
          </th>
          <th scope="col" className="whitespace">Raised by</th>
          
          {/* Conditionally render Raised on column */}
          {(user_info.role_id !== 10 && user_info.role_id !== 6 && user_info.role_id !== 7) && (
            <th scope="col">Raised on</th>
          )}

          <th scope="col" className="sortclass" onClick={() => sortTable('due_date')}>Due Date</th>
          <th scope="col" className="sortclass" onClick={() => sortTable('completed_date')}>Comp. Date</th>
          <th scope="col" className="sortclass" onClick={() => sortTable('approval_date')}>Approv. Date</th>
          {filtertype == 'sent' ?
          <>
          {/* <th scope="col" className="sortclass" onClick={() => sortTable('approval_date')}>Amount</th> */}
          <th scope="col" className="sortclass" onClick={() => sortTable('approval_date')}>Invoice description</th>
          <th scope="col" className="sortclass" onClick={() => sortTable('approval_date')}>Address</th>
          <th scope="col" className="sortclass" onClick={() => sortTable('approval_date')}>Invoice Email</th>
          </> : null }
          {filtertype == 'pending' ?
          <th scope="col" className="sortclass" >Send Mail</th>
          : null }
        </tr>
      </thead>
      <tbody>
        {dashboarddata && dashboarddata.length > 0 ? (
          dashboarddata.map((item, i) => (
            item ? (
              <React.Fragment key={i}>
                <tr
                  className={
                    i % 2 === 0
                      ? 'blue-row'
                      : i % 3 === 0
                      ? 'purple-row'
                      : 'orange-row'
                  }
                  edit-type={item.edittype}
                  edit-id={item.id}
                >
                  {/* Client Name and Phase toggle */}
                  <td className="whitespace">
                    <span
                      className="mb-0 text-sm text-bold"
                      style={{ cursor: 'pointer', fontWeight: '600' }}
                      onClick={() => taskDetail(item.task_id, i, item.id, item.edittype)}
                    >
                      {item.name} ({item.type}){" "}
                    </span>
                    {item.phases && item.phases.length > 0 && (
                      <Button
                        color=""
                        type="button"
                        style={{ padding: "revert" }}
                        onClick={() => handleExpand(item, i)}
                      >
                        {item.toggle ? <i className="fa fa-angle-up"></i> : <i className="fa fa-angle-down"></i>}
                      </Button>
                    )}
                  </td>
                  
                  <td className="whitespace">{item.sub_client}</td>
                  {(user_info.role_id === 10 || user_info.role_id === 6 || user_info.role_id === 7) && (
                    <td className="whitespace">{item.phases_list ? item.phases_list.desc : ''}</td>
                  )}
                  <td>{formatDate(item.year_end_date)}</td>
                  <td>{item.status_name}</td>
                  <td className="whitespace">{item.budget}</td>
                  {filtertype == 'sent' ?
                  <>
                  <td onClick={() => handlemaineditRow(i)}>
                    {item.mainediting ? (
                      <input
                        type="number"
                        className="form-control"
                        defaultValue={item.amount}
                        onBlur={(e) =>
                          editField(e.target.value, "amount", item.id, i)
                        }
                      />
                    ) : (
                      <span>{(item.amount != 0 && item.amount != null) ? '£'+item.amount+'+VAT' : 0}</span>
                    )}
                  </td>
                  <td onClick={() => handlemaineditRow(i)}>
                    {item.mainediting ? (
                      <input
                        type="date"
                        className="form-control"
                        defaultValue={item.invoice_date}
                        onBlur={(e) =>
                          editField(e.target.value, "invoice_date", item.id, i)
                        }
                      />
                    ) : (
                      <span>{formatDate(item.invoice_date)}</span>
                    )}
                  </td>
                </>
                  : null }
                  <td className="whitespace">{item.lead || ''}</td>
                  <td className="whitespace">{item.member || ''}</td>
                  <td className="whitespace">{item.raised_by}</td>
                  
                  {/* Conditionally render Raised on column */}
                  {(user_info.role_id !== 10 && user_info.role_id !== 6 && user_info.role_id !== 7) && (
                    <td>{formatDate(item.raised_date)}</td>
                  )}
                  <td>{formatDate(item.due_date)}</td>
                  {/* <td>{formatDate(item.completed_date)}</td> */}
                  {/* <td>{formatDate(item.approval_date)}</td> */}

                  {/* Editing Completed Date */}
                  <td >
                    
                      <span>{formatDate(item.completed_date)}</span>
                 
                  </td>

                  {/* Editing Approval Date */}
                  <td >
                   
                      <span>{formatDate(item.approval_date)}</span>
                  </td>
                  {filtertype == 'sent' ?
                  <>
                  
                  <td className="whitespace">{item.invoice_desc}</td>
                  <td className="whitespace">{item.invoice_address}</td>
                  <td className="whitespace">{item.invoice_email}</td>
                  </>
                  : null }
                  {/* Send Mail button */}
                  {filtertype == 'pending' ?
                  <td>
                    <button
                      type="button"
                      style={{ width: 'auto' }}
                      onClick={() => getpopupdata(item.id, item.name,i,item.sub_client)}
                      title="Send Mail"
                      className="btn-icon-clipboard btn btn-secondary"
                    >
                      <i className="fa fa-envelope" style={{ fontSize: "14px" }}></i>
                    </button>
                  </td>
                  : null }
                </tr>
              </React.Fragment>
            ) : null
          ))
        ) : (
          <tr>
            <td colSpan={13}>No Data Found!</td>
          </tr>
        )}
      </tbody>
    </Table>
              </div>
              </div>
              <CardFooter className="py-4">
              <div>
     
              <Paginationcomponent
        currentPage={currentPage}
        totalItems={total_page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={rowsPerPageOptions}
        handlePageClick={handlePageClick}
        handlePreviousClick={handlePreviousClick}
        handleNextClick={handleNextClick}
        handleRowsPerPageChange={handleRowsPerPageChange}
      />
                </div>
              </CardFooter>
            </Card>
          </div>
        </Row>
        <Row>
      

         
           
          {/* Comment Modal End */}
         
        </Row>
   

        {/* task detail popup */}
        <Row>
       
          <Modal
            size="lg"
            className="taskdetailmodal"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            toggle={() => setsendmailPopup(!sendmailpopup)}
            isOpen={sendmailpopup}
          >
            <div className="modal-header">
            
              <button
                aria-label="Close"
                className=" close"
                type="button"
                onClick={() => setsendmailPopup(false)}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <ModalBody style={{paddingTop:'0px'}}>
            
                <div>
    <p>Hi <input  name="name" type="text" onChange={(e) =>
                   inputhandler(
                     e,
                     "name",
                     
                   )} defaultValue={inputFields.name ? inputFields.name : ''} />,</p>
    
    <p>The service charge accounts for the below client has been completed and the fee invoice can be send to client. Please refer to the below details and do the needful:</p>
   
        <table   style={{ verticalAlign: 'top', width: '100%', margin: 0, backgroundColor: '#f9f9f9' }} cellPadding="0" cellSpacing="0"  id="main_table">
            <thead style={customStyles['#main_table tr th']}>
                <tr>
                    <th >Invoice date</th>
                    <th >Client Name</th>
                    <th >Block Name</th>
                    <th >Amount</th>
                    <th >Description</th>
                    <th >Address</th>
                    <th >Email</th>
                    <th >Contact Person</th>
                </tr>
            </thead>
            <tbody>
                <tr style={customStyles.oddRow}>
                  <td>
                    <Input type="date" placeholder="Invoice Date" name ="invoice_date"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "invoice_date",
                     
                   )} defaultValue={inputFields.invoice_date ? inputFields.invoice_date : ''} /></td>
                {/* <tr style={customStyles.oddRow}><td style={customStyles.cell}>Pending for Missing Information</td><td style={customStyles.cell} className="noofjob">{sendmailpopupdata.status_data[0].Onhold !== undefined ? sendmailpopupdata.status_data[0].Onhold : '-'}</td></tr> */}
              
                  <td >
                  <Input type="text" placeholder="Client Name" name ="client_name"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "client_name"
                     
                   )} />
                  {/* {selectedClientName} */}
                   </td>
                   <td><Input type="text" placeholder="Block Name" name ="block_name"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "block_name"
                     
                   )} defaultValue={inputFields.block_name ? inputFields.block_name : ''}  /></td>
                   <td><Input type="text" placeholder="Amount" name ="amount"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "amount"
                     
                   )} /></td>
                   <td><Input type="text" placeholder="Description" name ="description"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "description"
                     
                   )} /></td>
                   <td><Input type="text" placeholder="Address" name ="address"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "address"
                     
                   )} readOnly defaultValue={inputFields.address ? inputFields.address : ''} /></td>
                   <td><Input type="text" placeholder="Email" name ="email"  required
                  onBlur={(e) =>
                   inputhandler(
                     e,
                     "email"
                     
                   )} readOnly defaultValue={inputFields.email ? inputFields.email : ''} /></td>
                   <td><Input type="text" placeholder="Contact Person" name ="contact_person"  required
                    defaultValue={inputFields.contact_person ? inputFields.contact_person : ''}
                    readOnly
                    onBlur={(e) =>
                   inputhandler(
                     e,
                     "contact_person"
                     
                   )} /></td>
                   </tr>
               
            </tbody>
        </table>
        <br></br>
          <div className="mt-2">
  <Label>Add To Mail Id</Label>

  <div className="d-flex flex-wrap"> {/* Flex container for horizontal layout */}
  {sendmailbodydata.emailtoboxData.map((email, k) => (
          <div className="d-flex align-items-center " key={k}> {/* Flex item */}
            <div className=""> {/* Adjust column size as needed */}
              <FormGroup>
                <InputGroup className="input-group-alternative" style={{border:"1px solid grey"}}>
                  <Input
                    placeholder="Name"
                    type="text"
                    name="tomail"
                    value={email}
                    onChange={(e) => inputTomailhandler(e, k)}
                    required
                  />
                </InputGroup>
              </FormGroup>
            </div>

            <Col md="1" className="d-flex justify-content-center ml-2 mt--3" style={{ paddingTop: '-3px' }}>
             
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeToEmailbox(k)}
                >
                  <i className="fa fa-remove"></i>
                </button>
            
            </Col>
          </div>
          ))}
     
  </div>
  <FormGroup style={{ paddingTop: '3px' }}>
    <button className="btn btn-info" onClick={addTObox}>+ </button>
  </FormGroup>
  <br />
 
          </div>
          <div className="mt-2">
  <Label>Add CC Mail Id</Label>

  <div className="d-flex flex-wrap"> {/* Flex container for horizontal layout */}
    {sendmailbodydata.emailccboxData.map((email, k) => ( // Use map to iterate through emailccboxData
      <div className="d-flex align-items-center mb-2" key={k}> {/* Flex item */}
        <div className="col"> {/* Adjust column size as needed */}
          <FormGroup>
            <InputGroup className="input-group-alternative" style={{ border: "1px solid grey" }}>
              <Input
                placeholder="Name"
                type="text"
                name="ccmail"
                value={email} // Controlled input
                onChange={(e) => inputCCmailhandler(e, k)}
                required
              />
            </InputGroup>
          </FormGroup>
        </div>

        <Col md="1" className="d-flex justify-content-center mt--3" style={{ paddingTop: '0' }}>
         
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeEmailbox(k)} // Pass the correct index
            >
              <i className="fa fa-remove"></i>
            </button>
          
        </Col>
      </div>
    ))}
  </div>

  <FormGroup style={{ paddingTop: '3px' }}>
    <button className="btn btn-info" onClick={addCCbox}>+ </button>
  </FormGroup>
  <br />
</div>
    <br />
    <button type="button" className="col-2 dash-button btn btn-primary mt-4" onClick={(e) => sendmail(1)}  disabled={disablestate}>{disablestate ? 'Sending...' : 'Send Mail'}  </button>
    {sendmailpopupdata.data2 ? (
      <>
        {/* <table style={{ verticalAlign: 'top', width: '100%', margin: 0, backgroundColor: '#f9f9f9' }} cellPadding="0" cellSpacing="0"  id="main_table">
            <thead style={customStyles['#main_table tr th']} >
                <tr>
                    <th>Client Name</th>
                    <th>Year-End</th>
                    <th>Job received date</th>
                    <th>Expected Completion date</th>
                    <th>Completion date</th>
                    <th>Status</th>
                    <th>Budget</th>
                    <th>Remarks</th>
                </tr>
            </thead>
            <tbody>
                {sendmailpopupdata.data2.map((item, i) => (
                    <tr key={i} style={customStyles.oddRow}>

                        <td style={customStyles.cell}>{item.sub_client}</td>
                        <td style={customStyles.cell}>{item.year_end_date && item.year_end_date != '0000-00-00' ? new Date(item.year_end_date).toLocaleDateString('en-GB') : ''}</td>
                        <td style={customStyles.cell}>{item.raised_date && item.raised_date != '0000-00-00' ? new Date(item.raised_date).toLocaleDateString('en-GB') : ''}</td>
                        <td style={customStyles.cell}>{item.corient_expected_completed_date && item.corient_expected_completed_date != '0000-00-00' ? new Date(item.corient_expected_completed_date).toLocaleDateString('en-GB') : ''}</td>
                        <td style={customStyles.cell}>{item.completion}</td>
                        <td style={customStyles.cell}>{item.status_name}</td>
                       
                        <td style={customStyles.cell} onClick={()=> handleeditRow(i)}>
                  {item.editing ? (
                    <Input type="number" placeholder="impact" name ="financial_impact"   defaultValue={item.budget}
                    onBlur={(e) =>
                   inputhandler(
                     e,
                     "budget",
                     i,item.id
                   )} />
                  ) : <span>{item.budget}</span> }
              </td>
                        <td style={customStyles.cell}>{item.remarks}</td>
                    </tr>
                ))}
                {sendmailpopupdata.total_budet >= 0 &&
                <tr>
                    <td colSpan="6" style={customStyles.cell}></td>
                    <td style={customStyles.cell}>{sendmailpopupdata.total_budet}</td>
                    <td style={customStyles.cell} colSpan="1"></td>
                </tr>
                }
            </tbody>
        </table> */}
        <br></br>
        {/* <p>
        <textarea
        name="emailbody"
      className="form-control no-scroll" // Combine classes
      defaultValue={sendmailpopupdata.body}
      rows={3}
      cols={50}
      style={noscroll}
      onChange={(e) => changebody(e)}
    />
          </p> */}
          
        
          <br></br>
          <div className="mt-2">
  {/* <Label>Add To Mail Id</Label> */}

  {/* <div className="d-flex flex-wrap">
  {sendmailbodydata.emailtoboxData.map((email, k) => (
          <div className="d-flex align-items-center " key={k}>
            <div className=""> 
              <FormGroup>
                <InputGroup className="input-group-alternative" style={{border:"1px solid grey"}}>
                  <Input
                    placeholder="Name"
                    type="text"
                    name="tomail"
                    value={email}
                    onChange={(e) => inputTomailhandler(e, k)}
                    required
                  />
                </InputGroup>
              </FormGroup>
            </div>

            <Col md="1" className="d-flex justify-content-center ml-2 mt--3" style={{ paddingTop: '-3px' }}>
             
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeToEmailbox(k)}
                >
                  <i className="fa fa-remove"></i>
                </button>
            
            </Col>
          </div>
          ))}
     
  </div> */}
  {/* <FormGroup style={{ paddingTop: '3px' }}>
    <button className="btn btn-info" onClick={addTObox}>+ </button>
  </FormGroup> */}
  <br />
 
          </div>
          <div className="mt-2">
  {/* <Label>Add CC Mail Id</Label> */}

  {/* <div className="d-flex flex-wrap">
    {sendmailbodydata.emailccboxData.map((email, k) => (
      <div className="d-flex align-items-center mb-2" key={k}> 
        <div className="col"> 
          <FormGroup>
            <InputGroup className="input-group-alternative" style={{ border: "1px solid grey" }}>
              <Input
                placeholder="Name"
                type="text"
                name="ccmail"
                value={email} 
                onChange={(e) => inputCCmailhandler(e, k)}
                required
              />
            </InputGroup>
          </FormGroup>
        </div>

        <Col md="1" className="d-flex justify-content-center mt--3" style={{ paddingTop: '0' }}>
         
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => removeEmailbox(k)} // Pass the correct index
            >
              <i className="fa fa-remove"></i>
            </button>
          
        </Col>
      </div>
    ))}
  </div> */}

  {/* <FormGroup style={{ paddingTop: '3px' }}>
    <button className="btn btn-info" onClick={addCCbox}>+ </button>
  </FormGroup> */}
  <br />
</div>


       <br></br>
       
        </>
        
    ) : null}
      {/* <FormGroup style={{paddingTop:'3px'}}>
      <a className="btn btn-info"  onClick={(e) => addTobox()}>+ </a></FormGroup> */}
</div>

          
            
            </ModalBody>
            
           </Modal>
        </Row>
      </Container>
    </>
  );
};

const mapStateToProps = (state) => ({
  name: state.companysearch.name,
});

export default connect(mapStateToProps)(Billingdashboard);